// show in ordering of the enum
export enum SideMenuIcons {
  Default = 'default',
  Promo = 'promo',
  Wheel = 'wheel',
  Tournament = 'tournament',
  Jackpot = 'jackpot',
  Freespin = 'freespin',
  Win = 'win',
  // pseudo type: marks the queued active-promos announcement (a row of promo icons), not a real icon
  ActivePromos = 'activePromos'
}
// show in ordering of the enum
export const SideMenuIconToFont = {
  [SideMenuIcons.Default]: 'icon-new-lobby',
  [SideMenuIcons.Promo]: 'icon-side-ticket',
  [SideMenuIcons.Wheel]: 'icon-side-roulette',
  [SideMenuIcons.Tournament]: 'icon-tournament',
  [SideMenuIcons.Jackpot]: 'icon-side-slot',
  [SideMenuIcons.Freespin]: 'icon-side-fs',
  [SideMenuIcons.Win]: 'icon-navigation-winners',
  [SideMenuIcons.ActivePromos]: '' // never rendered - the promos announcement draws its own icons row
};
